// src/main.js
import { createApp } from 'vue';
import App from './App.vue';
import router from './routes/index.js'; // Your router import
import { createI18n } from 'vue-i18n';

// Import your translation files
import en from './locales/en.json';
import ro from './locales/ro.json';

// Define your messages object
const messages = {
  en,
  ro
};

// Determine initial locale (e.g., from localStorage or browser language)
// This logic checks if a language preference is stored, otherwise uses browser language,
// and falls back to 'en' if neither is 'en' or 'ro'.
//const storedLocale = localStorage.getItem('user-locale') || navigator.language.split('-')[0] || 'en';
//const initialLocale = ['en', 'ro'].includes(storedLocale) ? storedLocale : 'en';

// Create the i18n instance
const i18n = createI18n({
  locale: 'en', // set locale
  fallbackLocale: 'en', // set fallback locale if a translation is missing
  messages, // set locale messages
  legacy: false, // IMPORTANT: Use Composition API mode for Vue 3
  globalInjection: true, // IMPORTANT: This makes $t available in templates directly
});

const app = createApp(App);

app.use(router);
app.use(i18n); // Use the i18n plugin here

router.beforeEach((to, from, next) => {
  // Verifică dacă ruta are o cheie de titlu definită în meta
  if (to.meta.titleKey) {
    document.title = i18n.global.t(to.meta.titleKey);
  }
  next();
});

app.mount('#app');